/**
 * Legacy-Redirect: /reportings → /monthly-report
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/reportings')({
  beforeLoad: () => {
    throw redirect({ to: '/monthly-report', replace: true })
  },
  component: () => null,
})
